import React from "react";

function AdverserySimulation() {
  return (
    <div>
      <div class="Thumbnail"></div>
      <div class="ThumbnailMargin"></div>

      <div class="contentAfter col-md-10 mt-5 mb-5 p-2 ms-auto me-auto">
        <div class="text-center mb-5 w-full mx-auto">
          <span class="text-hollow text-transparent">Adversery Simulation</span>
        </div>
        <p>
          Adversary simulation investigates the security tools of an
          organization. Its comprehensive report gives the information about the
          working condition of the security system installed to make strategic
          decisions regarding the security of the sensitive information stored
          for the future. The sub-services we offer in adversary simulation are
          Red team assessment, Purple team assessment, and Blue team assessment.
        </p>
        <div class="row">
          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">Res Team Assessment</h5>
                <div class="card-text mt-3 mb-3"></div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">Purple Team Assessment</h5>
                <div class="card-text mt-3 mb-3"></div>
              </div>
            </div>
          </div>

          <div class="col-md-6 mt-5">
            <div class="card bg-light shadow-lg p-2">
              <div class="card-body">
                <h5 class="card-title">Blue Team Assessment</h5>
                <div class="card-text mt-3 mb-3">
                  <p>
                    Blue team assessment analysis your security to provide a
                    quick solution to all your problems. It secures your
                    business by identifying, blocking, and fighting the security
                    risks approaching your business while sustaining the regular
                    working pace without disruption.
                  </p>
                  <p>
                    Save yourself from cleaning a big dirty mess by an unwanted
                    guest later as/Rise fearlessly now with SIEM because-
                  </p>

                  <ol className="mt-3">
                    <li>
                      It detects the vulnerability points present in the
                      security tools.
                    </li>
                    <li>
                      It strengthens the security system by removing the risk.
                    </li>
                    <li>It maintains the business and security environment.</li>
                    <li>
                      It checks the traffic flow for smooth conduct and user
                      experience.
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdverserySimulation;
